import type { CaseCountersDTOV1, CaseCountersRequestConfig, GetCaseCountersParams } from '@/agent/types/case-counters'
import HttpService from '@/common/services/HttpService'
import type { CaseDetailsDTOV1, Case, CaseActionTypeDTOV1, CaseDTOV3, CaseActionParamsDTOV1, CaseFieldConfig } from '@/common/types/case'

export const getCase = async (caseId: number, { includes, expands }: CaseFieldConfig = {}): Promise<CaseDTOV3> => {
  const params = {
    include: includes?.size ? [...includes].join() : undefined,
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.getData<CaseDTOV3>(`/api/v3/cases/${caseId}`, {
    params,
  })
}

export const getCaseWorklog = async (caseId: number) => {
  return HttpService.post(`/api/v1/cases/${caseId}/worklogs`)
}

export const getCaseSkillExternalUrl = async (caseId: number): Promise<string> => {
  return HttpService.getData<string>(`/api/v3/cases/${caseId}/skill-external-url`)
}

export const getBulkCases = async (ids?: number[], { includes, expands }: CaseFieldConfig = {}): Promise<CaseDetailsDTOV1[]> => {
  const params = {
    include: includes?.size ? [...includes].join() : undefined,
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.postData<CaseDetailsDTOV1[]>(`/api/v1/bulk-cases/fetch`, { ids }, { params })
}

export const getCaseActionTypes = (params: CaseActionParamsDTOV1) => {
  return HttpService.getData<CaseActionTypeDTOV1[]>('/api/v1/cases/action-types', {
    params,
  })
}

export const getCaseCounters = ({ countBy, dataId, dataCode }: CaseCountersRequestConfig) => {
  const requestOptions = { params: { 'count-by': countBy } as GetCaseCountersParams }

  if (dataId) requestOptions.params['data-id'] = dataId
  else if (dataCode) requestOptions.params['data-code'] = dataCode
  else throw new Error('The getCaseCounters should be called with an identifier')

  return HttpService.getData<CaseCountersDTOV1>('/api/v1/cases/counters', requestOptions)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isCase(entity: any): entity is Case {
  return (entity as Case).currentSkillCode !== undefined
}

export const completeSessionOnCurrentTicket = () => {
  return HttpService.get(`/ticket/completeSession`)
}

export const cancelTicketCreation = () => {
  return HttpService.get(`ticket/create/cancel`)
}

export const updateCaseCustomer = (caseId: number, customerId: number) => {
  return HttpService.patchData(`/api/v3/cases/${caseId}/customer`, {
    customerId,
  })
}
